import React from 'react';
import { CheckIcon } from './icons/CheckIcon';
import { ArrowIcon } from './icons/ArrowIcon';
const problems = ["Ves resultados increíbles en otras artistas y pensás '¿por qué yo no logro eso?'", 'Tenés miedo de lastimar por no dominar presión y profundidad', 'No sabés qué agujas, productos o materiales usar', 'Practicás, pero sentís que te falta orden y seguridad', 'Querés empezar YA, pero nadie te explicó todo paso a paso y bien claro'];
export function PainPoints() {
  return <section className="py-12 px-4 bg-white" data-id="element-179">
      <div className="max-w-3xl mx-auto" data-id="element-180">
        <h2 className="text-xl md:text-2xl font-semibold text-[#3D3028] mb-8 text-center" data-id="element-181">
          Si hoy te sentís así, este Master es para vos
        </h2>

        <div className="bg-[#FAF8F4] rounded-2xl p-6 md:p-8 space-y-4" data-id="element-182">
          {problems.map((problem, index) => <div key={index} className="flex items-start gap-3" data-id="element-183">
              <div className="bg-[#E5A5A0]/10 p-1.5 rounded-full mt-0.5 flex-shrink-0" data-id="element-184">
                <CheckIcon className="w-3.5 h-3.5 text-[#E5A5A0]" data-id="element-185" />
              </div>
              <p className="text-[#3D3028]/80 text-sm md:text-base leading-snug" data-id="element-186">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="mt-6 bg-[#E5A5A0]/5 rounded-xl p-5 border-l-4 border-[#E5A5A0]" data-id="element-187">
          <div className="space-y-2" data-id="element-188">
            <div className="flex items-start gap-2" data-id="element-189">
              <ArrowIcon className="w-4 h-4 text-[#E5A5A0] mt-0.5 flex-shrink-0" data-id="element-190" />
              <p className="text-[#3D3028] font-medium text-sm" data-id="element-191">
                El problema no sos vos.
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-192">
              <ArrowIcon className="w-4 h-4 text-[#E5A5A0] mt-0.5 flex-shrink-0" data-id="element-193" />
              <p className="text-[#3D3028] font-medium text-sm" data-id="element-194">
                El problema es que nadie te dio una formación completa, guiada y
                profesional.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}